import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe, NgIf, NgClass, NgFor, DecimalPipe, TitleCasePipe, CurrencyPipe } from '@angular/common';
import { LanguageService, TranslationService, I18nModule } from '@spartacus/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { tap } from 'rxjs/operators';
import { ITBQuoteSelectProductsComponent } from 'src/app/shared/components/itb-quote-select-products/itb-quote-select-products.component';
import { ITBEditBidComponent } from 'src/app/shared/components/itb-edit-bid/itb-edit-bid.component';
import { DateRangePickerComponent } from 'ngx-daterange/components/datepicker/date-range-picker.component';
import { IDateRange} from 'ngx-daterange/interfaces';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { QuoteStatusModel } from '../../../core/model/quote-status-model';
import { pairwise } from 'rxjs/operators';
import { QuoteEditModel } from 'src/app/core/model/quote-edit-model';
import { QuoteActionModel } from 'src/app/core/model/quote-action-model';
import { ToastrService } from 'ngx-toastr';
import { ModalConfig } from '../../../core/model/modal.config-model';
import { AcceptBidModalComponent } from '../../../shared/components/accept-bid-modal/accept-bid-modal.component';
import { CancelBidModalComponent } from '../../../shared/components/cancel-bid-modal/cancel-bid-modal.component';
import { CouterOfferModalComponent } from '../../../shared/components/counter-offer-modal/counter-offer-modal';
import { RejectBidModalComponent } from '../../../shared/components/reject-bid-modal/reject-bid-modal.component';
import { UserAccountFacade } from '@spartacus/user/account/root';
import {EditBidModalComponent} from 'src/app/shared/components/edit-bid-modal/edit-bid-modal.component';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { QuoteSelectProductsComponent } from 'src/app/shared/components/quote-select-products/quote-select-products.component';
import { TenderCancelBidComponent } from 'src/app/shared/components/tender-cancel-bid/tender-cancel-bid.component';
import { TenderAcceptBidComponent } from 'src/app/shared/components/tender-accept-bid/tender-accept-bid.component';
import { TenderPlaceBidComponent } from 'src/app/shared/components/tender-place-bid/tender-place-bid.component';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { ConsignmentsPopupmodalComponent } from '../consignments/consignments-popupmodal/consignments-popupmodal.component';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { QuoteStatusStylePipe } from '../../../shared/pipes/quote-status-style-pipe';
@Component({
    selector: 'app-custom-myquotes-details',
    templateUrl: './custom-myquotes-details.component.html',
    styleUrls: ['./custom-myquotes-details.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, RouterLink, NgIf, NgClass, NgFor, AcceptBidModalComponent, CouterOfferModalComponent, RejectBidModalComponent, DecimalPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nModule, QuoteStatusStylePipe]
})
export class CustomMyquotesDetailsComponent implements OnInit {
  @ViewChild('acceptModal') private acceptModalComponent: AcceptBidModalComponent;
  // @ViewChild('cancelModal') private cancelBidModalComponent: CancelBidModalComponent;
  @ViewChild('counterOfferModal') private couterOfferModalComponent: CouterOfferModalComponent;
  @ViewChild('rejectModal') private rejectBidModalComponent: RejectBidModalComponent;

  public modalConfig: ModalConfig;
  quoteStatusModel = new QuoteStatusModel();
  quoteEditModel = new QuoteEditModel();
  quoteActionModel = new QuoteActionModel();
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  closeModal: any;
  enableLoader = true;
  startDate: any = null;
  endDate: any = null;
  timeSelected: any;
  startDateSingle: any = null;
  endDateSingle: any = null;
  datePipe = new DatePipe('en-US');
  quotesDataMain: any;
  QuoteId: any;
  selectedquote: any;
  tabbedquotesData: any;
  quantityRangeArrya = [];
  biddingTerms = '';
  quantitySelected: any;
  firstFieldEmittedValueSingleCal: IDateRange;
  firstFieldEmittedValue: IDateRange;
  form: UntypedFormGroup = null;
  form2: UntypedFormGroup = null;
  formSingle: UntypedFormGroup = null;
  browseType = 'quotesDetails';
  portsList: any;
  title: any;
  bidAttachments:any;
  objectKeys:any;
  selectedResponse: any;
  modalReference: any;
  quotesData: any;
  navigationData: string;
  selectedid: any;
  selectedprice: any;
  selectedquantity: any;
  myGroup: UntypedFormGroup;
  closeResult: string;
  dataQuotes: any;
  paymentTerm = '';
  termsAndConditions = '';
  error: string;
  @Input() tenderQuotesListData:any;
  tendersDetail:any;
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  loadport:any;
  pricingBasis:any;
  quotationperiod:any
  left = 0;
  spinner: boolean = false;
  errorMessage: any;
  writeAccess: any;
  isCustomerEmulated: any;
  isPlaceBidDisabled: boolean;
  isAcceptOfferDisabled: boolean;
  expiring: string;
  hour: string;
  min: string;
  second: string;
  lang: any;
  constructor(private toastrService: ToastrService,private translation: TranslationService, private router: Router, private cd: ChangeDetectorRef,
              private activatedRoute: ActivatedRoute, private customProductsService: CustomProductsService,
              private toastService: ToastrService, public ModalService:NgbModal,private userAccountFacade: UserAccountFacade,
              private customloginservice:CustomLoginService,private csAgentAuthService:CsAgentAuthService,
              private languageservice:LanguageService) {
  }
  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isPlaceBidDisabled = true;
          this.isAcceptOfferDisabled = true;
        }else{
          this.isPlaceBidDisabled = false;
          this.isAcceptOfferDisabled = false;
        }
      })
    })
   // this.tenderQuoteDetailsData();
    this.customProductsService.getHomeLinkActive(false);
    this.customProductsService.scrollToTop();
    this.userAccountFacade.get().subscribe((data: any) => {
      if (data) {
        const quoteCode = this.activatedRoute.snapshot.params.quoteId;
        this.translation.translate('breadcrumb.myQuotesDetails.pageTitle').subscribe(res => {
          this.title = res;
        });
        this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
          this.error = res;
        });
        this.languageservice.getActive().subscribe(res => {
          this.lang = res;
        })
        this.translation.translate('home.quote.Expiringin').subscribe(res => {
          this.expiring = res;

        });
        this.translation.translate('home.quote.h').subscribe(res => {
          this.hour = res;

        });
        this.translation.translate('home.quote.m').subscribe(res => {
          this.min = res;

        });
        this.translation.translate('home.quote.s').subscribe(res => {
          this.second = res;

        });
        this.getQuotesData(quoteCode);
        this.customProductsService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              if (this.router.url.indexOf('/quotes/myquotes') > -1) {
                this.getQuotesData(quoteCode);
              }
            }
          }
        });
      }
    });
    this.myGroup = new UntypedFormGroup({
      myGroupInput: new UntypedFormControl()
    });

  }
  // tslint:disable-next-line:typedef
  changeRespond() {
  }
  getQuotesData(quoteStatus): any {
    this.customProductsService.getQuotesDetails(quoteStatus).subscribe(
      (result) => {
        if (
          result.quoteEntries[0].quoteBHPDelivery !== undefined &&
          result.quoteEntries[0].quoteBHPDelivery.length !== undefined &&
          result.quoteEntries[0].quoteBHPDelivery.lenght !== 0
        ) {
          if (result.quoteEntries[0].quoteBHPDelivery[0].paymentTerms) {
            this.paymentTerm =
              result.quoteEntries[0].quoteBHPDelivery[0].paymentTerms;
          }
          if (result.quoteEntries[0].quoteBHPDelivery[0].termsAndConditions) {
            this.termsAndConditions =
              result.quoteEntries[0].quoteBHPDelivery[0].termsAndConditions;
          }
        }
        if (
          result.quoteBHPDelivery !== undefined &&
          result.quoteBHPDelivery.length !== undefined &&
          result.quoteBHPDelivery.lenght !== 0
        ) {
          if (result.quoteBHPDelivery[0].paymentTerms) {
            this.paymentTerm = result.quoteBHPDelivery[0].paymentTerms;
          }
          if (result.quoteBHPDelivery[0].termsAndConditions) {
            this.termsAndConditions =
              result.quoteBHPDelivery[0].termsAndConditions;
          }
        }
        if (result != null && result !== undefined) {
          this.quotesData = result;
          if (this.quotesData) {
            if (this.quotesData.commodityType == 'CN') {
              if (this.quotesData.quoteEntries?.length > 0) {
                this.quotesData.quoteEntries.forEach((row) => {
                  if (row.rcPrice) {
                    row.rcPrice.value = row.rcPrice.value;
                  }
                  if (row.tcPrice) {
                    row.tcPrice.value = row.tcPrice.value;
                  }
                });
              }
            }
          }
          let todayDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          let invitationToBidSubmissionDeadline = moment(
            this.quotesData.invitationToBidSubmissionDeadline
          ).format('YYYY-MM-DD HH:mm:ss');
          this.quotesData.editCancelBidDisplay =
            invitationToBidSubmissionDeadline < todayDate ? false : true;
          this.modifyResponsetoCombinedList();
          this.bidAttachment('', '');
          for (let a of this.quotesData.combinedTenders) {
            this.loadport = a.loadPort ? a.loadPort : '';
            this.pricingBasis =
              a.pricingBasis != undefined
                ? a.pricingBasis.map((o) => o.description)
                : '';
            this.quotationperiod =
              a.defaultQuotationPeriod != undefined
                ? a.defaultQuotationPeriod.description
                : a.quotationPeriod != undefined
                ? a.quotationPeriod.description
                : '';
            this.quotesData.pricingBase = this.pricingBasis;
            this.quotesData.qp = this.quotationperiod;
          }
          if (this.quotesData.quoteEntries[0].product.features !== undefined) {
            if (
              this.quotesData.quoteEntries[0].product.features.entry !==
              undefined
            ) {
              // tslint:disable-next-line:typedef
              // tslint:disable-next-line:only-arrow-functions
              // tslint:disable-next-line:typedef
              this.quotesData.quoteEntries[0].product.features.entry.sort(
                function (a, b) {
                  const textA = a.value;
                  const textB = b.value;
                  return textA < 0 ? -1 : textB < 0 ? 1 : textB - textA;
                }
              );
            }
          }
          if (this.quotesData?.quoteEntries[0]?.priceList?.length > 0) {
            let index = this.quotesData.quoteEntries[0].priceList.findIndex(x=>x.kopCode == 'BASE')
            if (index != -1) {
              this.quotesData.quoteEntries[0].priceList.splice(index, 1);
            }
            
            this.quotesData.quoteEntries[0].priceList =
              this.quotesData.quoteEntries[0].priceList.sort((a, b) => {
                const nameA = a.kopName?.toUpperCase(); // Convert to uppercase for case-insensitive sort
                const nameB = b.kopName?.toUpperCase(); // Convert to uppercase for case-insensitive sort

                if (nameA < nameB) {
                  return -1; // nameA comes before nameB
                }
              });
          }
          this.enableLoader = false;
        } else {
          this.toastService.show('Error loading this page:' + this.error);
        }
      },
      (err) => {
        this.errorMessage = err;
        this.toastService.show('Sorry something went wrong, please try again!');
        this.enableLoader = false;
      }
    );
  }
  // tenderQuoteDetailsData(){
  //   this.customProductsService.getTendersQuoteDetailsData().pipe(tap(_=>console.log(_))).subscribe((data:any) => {
  //     //this.tenderDetailsData= data.tenders;
     
  // });
  // }
  convertDateAndTime(dateString,timezone): any {
    if (dateString) {
      if(timezone){
        return moment.parseZone(dateString).utcOffset(timezone.timeZoneFormat).format('DD/MM/YYYY HH:mm');
      }
      else{
        return moment(dateString).format('DD/MM/YYYY HH:mm');
      }
    
    }else{
      return '';
    }
  }
  convertDate(dateString): any {
    if (dateString) {
     // const momentObj = moment(dateString);
      return moment.utc(dateString).local().format('DD/MM/YYYY');
     // return  momentObj.format('YY/MM/DD');
    }
  }
  convertTime(dateString): any {
    if (dateString) {
      const dateSplit = dateString.split('T');
      const timeSplit = dateSplit[1].split('+');
      return timeSplit[0];
    }
  }
  expiryCalculate(quoteValidity): string{
    if (quoteValidity){
      return this.expiryCalculator(quoteValidity);
     // return this.customProductService.expiryCalculate.call(this,quoteValidity);
    }
  }
  expiryCalculator(validityDate): any {
    let counterTime = '';
    validityDate = moment(validityDate);
    const eventTime1 = validityDate.format(); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
    const eventTime: any = moment(eventTime1).format('X');
    const currentTime: any = moment().format('X'); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
    const diffTime = eventTime - currentTime;
    let duration: any = moment.duration(diffTime * 1000, 'milliseconds');
    const interval = 1000;
    duration = moment.duration(duration - interval, 'milliseconds');
    const dayRem = duration.days();
    const hRem = duration.hours();
    const mRem = duration.minutes();
    const sRem = duration.seconds();

    
    if(this.lang == 'en'){
      counterTime = this.expiring;
      if (dayRem > 0) {
        counterTime = '';
      }else{
        if (hRem > 0) {
          counterTime += hRem + this.hour;
        }
        if (mRem > 0) {
          counterTime += mRem + this.min;
        }
        if(sRem > 0){
          counterTime += sRem + this.second;

        }
        if (dayRem <= 0 && hRem <= 0 && mRem <= 0 && sRem <= 0) {
          counterTime = '';
        }
      }
    }
    if(this.lang == 'zh'){
      counterTime = '';
      if (dayRem > 0) {
        counterTime = '';
      }else{
        if (hRem > 0) {
          counterTime += hRem + this.hour;
        }
        if (mRem > 0) {
          counterTime += mRem + this.min;
        }
        counterTime += this.expiring
        if (dayRem <= 0 && hRem <= 0 && mRem <= 0) {
          counterTime = '';
        }
      }
    }
    return counterTime;
  }

  // tslint:disable-next-line:typedef
  async openAcceptModal(data?: any) {
    return await this.acceptModalComponent.open(data);
  }
  // tslint:disable-next-line:typedef
    openCancelModal(data?: any,fromScreen?:string) {
    
    const modalRef = this.ModalService.open(CancelBidModalComponent, { centered: true , size: 'md'});
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.from = fromScreen;
  }
  // tslint:disable-next-line:typedef
  async openRejectModal(data?: any) {
    return await this.rejectBidModalComponent.open(data);
  }
  // tslint:disable-next-line:typedef
  async openCounterOfferModal(content: any, data?: any) {
    data.portName = null;
    if (data.quoteEntries !== undefined) {
      if (data.combinedTenders[0].portName !== undefined) {
        data.portName = data.combinedTenders[0].portName;
      }
      if (data.combinedTenders[0].product !== undefined) {
        if (data.combinedTenders[0].product.maximumQty !== undefined && data.combinedTenders[0].product.minimumQty !== undefined) {
          data.maximumQty = data.combinedTenders[0].product.maximumQty;
          data.minimumQty = data.combinedTenders[0].product.minimumQty;
        }
      }
    }
    return await this.couterOfferModalComponent.open(content, data);
  }
  openmodal(screen:any){
    if(this.quotesData?.combinedTenders?.length <= 1){
      if(this.quotesData?.commodityType=='IO' || this.quotesData?.commodityType=='CC' || this.quotesData?.commodityType=='CA'){
    const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.tabName=this.quotesData.combinedTenders[0].pricingOptionsEnum[0].pricingOptions;
    ModalRef.componentInstance.screen=screen;  
    if(this.quotesData?.combinedTenders[0].childList){
      this.quotesData?.combinedTenders[0].childList.forEach(element=>{
        element.priceshw = element.relativePrice?element.relativePrice.value:'';
        element.indexPriceshw = element.premiumDiscount?element.premiumDiscount.value:'';
      })
    }
    ModalRef.componentInstance.quantityshw = this.quotesData?.combinedTenders[0].quantity;
    ModalRef.componentInstance.dischargePortshw = this.quotesData?.combinedTenders[0].dischargePortDetails;
    ModalRef.componentInstance.productsInfo=this.quotesData;
    ModalRef.componentInstance.indexPrice = this.quotesData && this.quotesData?.combinedTenders[0].premiumDiscount && this.quotesData?.combinedTenders[0].premiumDiscount.value || '';    
    ModalRef.componentInstance.price = this.quotesData && this.quotesData?.combinedTenders[0].relativePrice && this.quotesData?.combinedTenders[0].relativePrice.value || '';
    if(this.quotesData?.combinedTenders[0].minimumQuantity && this.quotesData?.combinedTenders[0].maximumQuantity){
      ModalRef.componentInstance.quantity = this.quotesData?.combinedTenders[0].quantity;
      }  

      }
      if(this.quotesData?.commodityType=='CN'){
        const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
        ModalRef.componentInstance.productsInfo=this.quotesData;
        ModalRef.componentInstance.screen=screen;
        if(this.quotesData?.combinedTenders[0].childList){
        this.quotesData?.combinedTenders[0].childList.forEach(element=>{
          element.priceshw=element.tcPrice?element.tcPrice.value:'';
          element.indexPriceshw = element.rcPrice?element.rcPrice.value:'';
      })
    }
    ModalRef.componentInstance.price = this.quotesData && this.quotesData.combinedTenders[0].tcPrice && this.quotesData.combinedTenders[0].tcPrice?.value || '';    
    ModalRef.componentInstance.indexPrice = this.quotesData && this.quotesData.combinedTenders[0].rcPrice && this.quotesData.combinedTenders[0].rcPrice?.value || '';  
      ModalRef.componentInstance.quantityshw = this.quotesData?.combinedTenders[0].quantity;
      ModalRef.componentInstance.dischargePortshw = this.quotesData?.combinedTenders[0].dischargePortDetails;
        ModalRef.componentInstance.priceshw = this.quotesData && this.quotesData?.combinedTenders[0].tcPrice && this.quotesData?.combinedTenders[0].tcPrice?.value || '';    
        ModalRef.componentInstance.indexPriceshw= this.quotesData && this.quotesData?.combinedTenders[0].rcPrice && this.quotesData?.combinedTenders[0].rcPrice?.value || '';    
      }
    }
    else if(this.quotesData?.commodityType=='IO' || this.quotesData?.commodityType=='CC' || this.quotesData?.commodityType=='CA'){
          const ModalRef = this.ModalService.open(QuoteSelectProductsComponent,{centered: true,size:'md'});
          this.quotesData?.combinedTenders.map(val=>{
            val.checked = true;
            ModalRef.componentInstance.parameter=this.quotesData?.combinedTenders;
            val.quantityshw = val.quantity;
            val.dischargePortshw = val.dischargePortDetails;
          })
          ModalRef.componentInstance.productsInfo = this.quotesData;
          ModalRef.componentInstance.price =this.quotesData && this.quotesData?.combinedTenders[0].relativePrice && this.quotesData?.combinedTenders[0].relativePrice.value || '';
          if(this.quotesData?.combinedTenders[0].minimumQuantity && this.quotesData?.combinedTenders[0].maximumQuantity){
            ModalRef.componentInstance.quantity = this.quotesData?.combinedTenders[0].quantity;
            }  
        
        }
        if(this.quotesData?.commodityType=='CN' && this.quotesData?.combinedTenders.length > 1){
          const ModalRef = this.ModalService.open(ITBQuoteSelectProductsComponent,{centered: true,size:'md'});
          this.quotesData?.combinedTenders.map(val=>{
            val.checked = true;
            ModalRef.componentInstance.parameter=this.quotesData?.combinedTenders;
            val.quantityshw = val.quantity;
            val.dischargePortshw = val.dischargePortDetails;
          })
          ModalRef.componentInstance.productsInfo = this.quotesData;
          ModalRef.componentInstance.price =this.quotesData && this.quotesData?.combinedTenders[0].relativePrice && this.quotesData?.combinedTenders[0].relativePrice.value || '';
          ModalRef.componentInstance.indexPrice =this.quotesData && this.quotesData?.combinedTenders[0].relativePrice && this.quotesData?.combinedTenders[0].relativePrice.price || '';
        }
        if(this.quotesData?.commodityType=='PO'){
          const ModalRef = this.ModalService.open(ConsignmentsPopupmodalComponent,{centered: true,size:'md'});
          ModalRef.componentInstance.productsInfo=this.quotesData;
        }
      }
  cancelmodal(){
    const ModalRef = this.ModalService.open(TenderCancelBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.productsInfo=this.quotesData;
  }
  acceptbid(){
    const ModalRef = this.ModalService.open(TenderAcceptBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.productsInfo=this.quotesData;
  }
  downloadDesktopEDRPDF() {
    this.spinner = true;
    this.cd.detectChanges();
   this.left = window.outerWidth/2;
    this.customProductsService.getEDRData(this.quotesData.c4cQuoteExternalQuoteId).subscribe(res=>{
      const ref = document.createElement("a");
      if(res.pdfBinary){
        ref.href = `data:application/pdf;base64,${res.pdfBinary}`
        ref.download = `TransactionDetails_${this.quotesData.c4cQuoteExternalQuoteId}.pdf`
        ref.click()
        this.spinner = false;
        this.toastService.show('Document downloaded successfully');
      }else{
        this.spinner = false;
        this.toastService.show(res.error);
      }
     
    },err=>{
      this.spinner = false;
      this.errorMessage = err;
      this.toastrService.show("Sorry something went wrong, please try again!");
    })
  }
  downloadDesktopPDF() {
    this.spinner = true;
    this.cd.detectChanges();
   this.left = window.outerWidth/2;
    const quoteCode = this.activatedRoute.snapshot.params.quoteId;
    this.customProductsService.getPDFData(quoteCode).subscribe(res=>{
      if(res.pdfBinary){
        const ref = document.createElement("a");
        ref.href = `data:application/pdf;base64,${res.pdfBinary}`
        console.log(res,'resp')
        ref.download = `Transaction Confirmation-${this.quotesData.c4cQuoteExternalQuoteId}.pdf`
        ref.click()
        this.spinner = false;
        this.toastService.show('Document downloaded successfully');
      }else{
        this.spinner = false;
        this.toastService.show(res.error);
      }
   
    }, (err: any)=>{
      this.enableLoader = false;
      this.errorMessage = err;
      this.toastrService.show("Sorry something went wrong, please try again!");
     
    })
  }
bidAttachment(base64,event){
  this.spinner = true; 
  this.objectKeys=Object.keys;
//  let c4cUUID = '07395C4150A61EEDB58BCA0562F30349';
   const c4cUUID = this.quotesData.c4cUUID?this.quotesData.c4cUUID:'';
  this.cd.detectChanges();
 this.left = window.outerWidth/2;
 if(c4cUUID!='' && (this.quotesData.quoteState == 'OFFER_RECEIVED' || this.quotesData.quoteState =='ACCEPTED')){
  this.customProductsService.getBidAttachmentData(c4cUUID).subscribe(res=>{
    this.bidAttachments=(res.error=='No Document Available to download')?res='':res
    this.spinner=false
    if(event!='' && base64!=''){
           const ref = document.createElement("a");
           ref.href = `data:application/pdf;base64,${base64}`
           ref.download = event.target.innerHTML
           ref.click()
           this.toastService.show('Document downloaded successfully');
         }
        }, (err: any)=>{
          this.spinner = false;         
        })
 }else{
  this.spinner=false
 }
}
modifyResponsetoCombinedList(){
    if(this.quotesData.quoteEntries?.length>1){
      var tendersListithSetInfo = this.quotesData.quoteEntries.filter(x=>(x.set!='' && x.set!=undefined));
      if(tendersListithSetInfo?.length>0){
        var ObjectWhichContainsSetInfo= this.groupBy(tendersListithSetInfo,'set');
        var groupList=[];
        for(let item in ObjectWhichContainsSetInfo){
          var newName = ''
          var mainObject:any = {};
          var mainAvailable = false;
          var OptionalTendersWIthoutAnyMain = [];
          var childList = []
          tendersListithSetInfo.forEach(element => {
            if(item == element.set){
              newName = newName+element.productName+' or ';
              element.newName = newName;
              if(element.materialOption == 'MAIN'){
                mainAvailable = true;
                mainObject = Object.assign(element);
              }
              else if(mainAvailable == false){
                element.newName = undefined;
                OptionalTendersWIthoutAnyMain.push(element);
              }
              
              mainObject.newName = newName;
              childList.push(element);
            }
          });
          mainObject.newName = mainObject.newName.substring(0,mainObject.newName.length-4);
          mainObject.childList = childList;
          if(mainAvailable){
            groupList.push(mainObject);
          }
          if(groupList.length>0){
            this.quotesData.groupTenders = groupList;
          }else{
            this.quotesData.groupTenders = [];
          }
          this.quotesData.IndividualTenders = this.quotesData.quoteEntries.filter(x=>(x.set=='' || x.set == undefined));
         
          if(OptionalTendersWIthoutAnyMain?.length>0){
            this.quotesData.IndividualTenders = this.quotesData.IndividualTenders.concat(OptionalTendersWIthoutAnyMain);
          }
        }
        this.quotesData.combinedTenders=[...this.quotesData?.groupTenders,...this.quotesData.IndividualTenders];
      }
      else{
        this.quotesData.IndividualTenders = this.quotesData.quoteEntries
        this.quotesData.combinedTenders=this.quotesData.IndividualTenders

      }
    }
    else{
      this.quotesData.IndividualTenders = this.quotesData.quoteEntries
      this.quotesData.combinedTenders=this.quotesData.IndividualTenders
    }
    console.log(this.quotesData,'tenders');
  
  
}
groupBy = (arr, property) => {
  return arr.reduce((acc, cur) => {
    acc[cur[property]] = [...acc[cur[property]] || [], cur];
    return acc;
  }, {});
}
formatQPDates(data){
  
  if(data?.defaultQuotationPeriod?.finalQPDateFrom && data?.defaultQuotationPeriod?.finalQPDateTo && data.defaultQuotationPeriod.description=='Fixed QP'){
    let formatedQPDateFROM =  new Date(data.defaultQuotationPeriod.finalQPDateFrom).getDate() + '/' + 
                              (new Date(data.defaultQuotationPeriod.finalQPDateFrom).getMonth()+1) + '/' +
                              new Date(data.defaultQuotationPeriod.finalQPDateFrom).getFullYear() 
    let formatedQPDateTo =  new Date(data.defaultQuotationPeriod.finalQPDateTo).getDate() + '/' + 
                              (new Date(data.defaultQuotationPeriod.finalQPDateTo).getMonth()+1) + '/' +
                              new Date(data.defaultQuotationPeriod.finalQPDateTo).getFullYear() 
    return formatedQPDateFROM + ' - ' + formatedQPDateTo + ' (both dates inclusive)';
  }
  else{
    return data?.defaultQuotationPeriod?.description?data.defaultQuotationPeriod.description:'--'
  }
  
}
getPricingBasisBasedOnOption(pricingOption,description){
  return this.customProductsService.getPricingBasisBasedOnOption(pricingOption,description)
}
getLabelofConfirmScreen(priceOptions,commodityType,page){
  return this.customProductsService.getLabelofConfirmScreen(priceOptions,commodityType,page);

}
getPriceandSymbol(priceOptions,data,commodityType){
  let price = this.getPrice(data);
return this.customProductsService.getPriceandSymbol(priceOptions,price,commodityType);
}
getPrice(data){
  if(data?.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' || data?.pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE' || data?.pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM'){
    return data?.premiumDiscount?.value;
  }
  else if( data?.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE' ){
    let price = '';
    price = data?.relativePrice?.value;
    return price;
  }
}
editOrder(quotesData){  
  if (quotesData.commodityType == 'PO') {
    const ModalRef = this.ModalService.open(ConsignmentsPopupmodalComponent, {
      centered: true,
      size: 'md',
    });
    console.log(quotesData);
    ModalRef.componentInstance.EditOrders = quotesData;
    ModalRef.componentInstance.popUp = 'Edit Order';
}
}
}
